import React from 'react';
import { useStoreMap } from 'effector-react';
import { tlTime } from '@utils/tlTime';
import { $rotateCurrentLeft } from '@stores/autoRotateStores';
import { PX_PER_SEC } from '../constants';

export function RotateCurrentTime() {
  const curLeft = useStoreMap({
    store: $rotateCurrentLeft,
    keys: [],
    fn: (left) => tlTime(left / PX_PER_SEC),
  });
  return (
    <div className="flex h-40 items-center justify-center border-b border-black-#34 text-black-gray">
      {curLeft}
    </div>
  );
}
